import { convertToChannelGroup } from "util/constants";

export enum MarketingStatus {
  NOT_REQUESTED = "not_requested",
  ENABLED = "enabled",
  DISABLED = "disabled",
}

export default class CustomerChannelDomain {
  id?: string;

  type: string;

  handle: string;

  displayHandle?: string;

  isActive: boolean;

  marketingStatus?: MarketingStatus;

  getChannelGroup(): string {
    return convertToChannelGroup(this.type);
  }

  getDisplayChannelName(): string {
    switch (this.type) {
      case "sms":
        return "SMS";
      case "whatsapp":
        return "WhatsApp";
      case "facebook":
        return "Facebook messenger";
      case "instagram":
        return "Instagram";
      case "email":
        return "Email";
      default:
        return "";
    }
  }

  getMarketingStatusDisplay(): string {
    switch (this.marketingStatus) {
      case MarketingStatus.NOT_REQUESTED:
        return "Not Subscribed";
      case MarketingStatus.ENABLED:
        return "Subscribed";
      case MarketingStatus.DISABLED:
        return "Unsubscribed";
      default:
        return "-";
    }
  }

  constructor(
    id: string | undefined,
    type: string,
    handle: string,
    displayHandle: string | undefined,
    isActive: boolean,
    marketingStatus: MarketingStatus | undefined
  ) {
    this.id = id;
    this.type = type;
    this.handle = handle;
    this.displayHandle = displayHandle;
    this.isActive = isActive;
    this.marketingStatus = marketingStatus;
  }
}
